export const MIN_QUERY_LENGTH = 3;
